import { render, staticRenderFns } from "./UpdatesTimeline.vue?vue&type=template&id=1c3ee808&"
import script from "./UpdatesTimeline.vue?vue&type=script&lang=ts&"
export * from "./UpdatesTimeline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports